
import callAPI from '../fetch/main';


const createPaymentLink  = (plan , messageApi , loadingState , checkoutState ) => {

    messageApi.open({
      type: 'loading',
      content: 'Please wait',
      duration: 0,
      key:'payment-process'
    });
  
    let apiURL = `create_subscription`
    callAPI({ url: apiURL, method: "POST", body: {"plan_price":plan}, loadingState: loadingState, dataState: checkoutState })
  }

export default createPaymentLink;